import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
	components: {
		swiper,
		swiperSlide
	},
	data() {
		return {
			notNextTick: true,
			sld03SliderOption: {
				autoplay: false,
				loop: false,
				autoHeight: true,
				mousewheelControl: true,
				slidesPerView: 'auto',
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null,
				},
				pagination: {
					el: this.pagination || null,
					clickable: true
				},
				spaceBetween: 32,
				slidesPerView: 4,
				breakpoints: {
					479: {
						slidesPerView: 1
					},
					767: {
						spaceBetween: 12,
						slidesPerView: 2
					},
					1439: {
						spaceBetween: 12,
						slidesPerView: 3
					}
				},
				mousewheel: false
			}
		}
	},
	props: [
		'nextButton',
		'prevButton',
		'pagination'
	]
}



// WEBPACK FOOTER //
// ../source/modules/SLD03-product-slider/SLD03-product-slider.js